<p>{{ question | json }}</p>

<mat-form-field class="input-width">
  <mat-label>Text Before</mat-label>
  <textarea type="text" matInput [(ngModel)]="question.question"></textarea>
</mat-form-field>
<div *ngFor="let blank of question.blanks" class="blank">
  <mat-form-field class="input-width">
    <mat-label>Text Before</mat-label>
    <input matInput [(ngModel)]="blank.textBefore" />
  </mat-form-field>
  <mat-form-field class="input-width">
    <mat-label>Text After</mat-label>
    <input matInput [(ngModel)]="blank.textAfter" />
  </mat-form-field>
</div>
